<div class="overflow-y-auto max-h-[75vh] hide-scrollbar md:show-scrollbar">
  <div
    class="relative w-[434px] max-w-full h-full px-8 py-14 rounded flex flex-col gap-4"
    [style.backgroundColor]="bgBase()"
  >
    <neopos-icon name="email-circle" class="text-[58px] mb-4 mx-auto" />

    <p class="text-center font-medium text-lg leading-none">
      {{ 'Link do resetowania hasła został wysłany' | translate }}
    </p>

    <p class="text-sm leading-none text-center text-gray-700">
      {{
        'Wysłaliśmy wiadomość e-mail z linkiem umożliwiającym ustawienie nowego hasła. Sprawdź swoją skrzynkę — czasem wiadomość trafia do folderu SPAM.'
          | translate
      }}
    </p>

    <acc-button
      type="button"
      [inputId]="'acc-button-restore-password-summary-return'"
      theme="SECONDARY"
      widthType="fit"
      (onClick)="onReturnToLogin()"
      [attr.ariaLabel]="(loggedUser ? 'Wróć' : 'Wróć do logowania') | translate"
      class="mt-4 mx-auto"
    >
      {{ (loggedUser ? 'Wróć' : 'Wróć do logowania') | translate }}
    </acc-button>
  </div>
</div>
